module.exports = __webpack_public_path__ + "static/img/news21-cover.5ac61bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news21-cover.jpg
// module id = JYif
// module chunks = 0